<template>
  <div class="not-found">
    <h1>404</h1>
    <h2>{{ $t('web.not_found.card_header') }}</h2>
    <div class="links">
      <router-link :to="{ name: 'Login'}" v-if="!loggedIn && validSite">
        {{ $t('web.not_found.login_link') }}
      </router-link>
      <router-link :to="{ name: 'Dashboard' }" v-if="loggedIn && validSite">
        {{ $t('web.not_found.dashboard_link') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import util from '@/functions'

export default {
  data () {
    return {
      loggedIn: util.isLoggedIn(),
      validSite: this.$store.state.websiteConfig.id !== null
    }
  }
}
</script>

<style lang="sass" scoped>
.not-found
  text-align: center
</style>




// WEBPACK FOOTER //
// NotFound.vue?4a4564a0